import { Component } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';
import { LoginPage } from '../login/login';

// import { ShariahServiceProvider } from '../../providers/shariah-service/shariah-service';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})
export class RegisterPage {
  // username:string;
  email:string;
  password:string;
  passwordConf:string;
  check_tnc: boolean = false;
  title:string;
  subtitle:string;

  constructor (
    public navCtrl: NavController,
    private http:HttpClient,
    private appConfig:AppConfigProvider,
    private alertCtrl:AlertController,
    private iab: InAppBrowser,
  ) {

  }

  async signup(){
    // const email = await this.shariahService.verifyEmail(this.email).subscribe((data: any) => data);

    // const url = `https://api.trumail.io/v2/lookups/json?email=${this.email}`;

    // const verify_email = await fetch(url);
    // const email_status = await verify_email.json();

    // if (email_status.deliverable) {

    // } else {
    //   this.title = 'Error';
    //     this.subtitle = 'Email is not valid.';
    //     this.alertMessage();
    // }

    const formdata = new FormData();
    // formdata.append('username',this.username);
    formdata.append('email',this.email);
    formdata.append('password',this.password);
    formdata.append('app_key',this.appConfig.appKey());
    formdata.append('email',this.email);

    if (this.check_tnc == true) {
      if (this.passwordConf === this.password) {
        this.http.post(this.appConfig.apiUrl()+'index.php/api/login/register', {
          // username: this.username,
          email: this.email,
          password: this.password,
          app_key: this.appConfig.appKey(),
        }).subscribe((res:any) => {
          if(res.is_register){
            this.title    = 'Success';
            this.subtitle = 'Account created successfully. Please check your email to activate your account before login or reset your password.';
            this.alertMessage();

            this.navCtrl.push(LoginPage);
          }else{
            console.log('failed register the apps'+JSON.stringify(res));
            this.title    = 'Failed';
            this.subtitle = 'Unable to register new account. '+res.message;
            this.alertMessage();
          }
        }, err => {
          console.log(err);
          this.title = 'Failed';
          this.subtitle = 'Unable to register new account. '+err.error.message;
          this.alertMessage();
        });

      } else {
        this.title = 'Error';
        this.subtitle = 'Password don\'t match. Please update your password.';
        this.alertMessage();
      }

    } else {
      this.title = 'Error';
      this.subtitle = 'Please read and check our terms and conditions before sign up.';
      this.alertMessage();
    }
  }

  alertMessage() {
    let alert = this.alertCtrl.create({
      title: this.title,
      subTitle: this.subtitle,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  async openTnc() {
    const options: InAppBrowserOptions = {
      location: 'yes',
      zoom: 'no'
    }

    await this.iab.create('http://salihin.noip.me/syariah-admin/uploads/tnc/salihin_app_tnc.pdf', '_system', options);
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts